/**
 * Confirm modal before starting bulk Mark as Done; shows selection count and a non-cancellable warning.
 */
import { observer } from "mobx-react";
import { ConfirmModal } from "../../../../../components/modal/components/confirm-modal/confirm-modal";
import { BUTTON_VARIANTS } from "../../../../../components/inputs/button-variants";
import { Note, NOTE_TYPE } from "../../../../../components/note/note";
import useDashboardTranslation from "../../../../../dashboard-translation/hooks/dashboard-translation-hook";

interface IProps {
    selectionCount: number;
    isLoading: boolean;
    onCancel: () => void;
    onConfirm: () => void;
}

const RmaListBulkMarkDoneConfirmModal: React.FC<IProps> = observer(({
    selectionCount,
    isLoading,
    onCancel,
    onConfirm,
}) => {
    const { getTranslation } = useDashboardTranslation();
    const scope = "dashboard-returns-page";
    const count = String(selectionCount);

    return (
        <ConfirmModal
            title={getTranslation("BULK_MARK_DONE_TITLE", scope, [count])}
            text={getTranslation("BULK_MARK_DONE_CONFIRM_BODY", scope)}
            implicationText={(
                <Note
                    type={NOTE_TYPE.WARNING}
                    body={getTranslation("BULK_MARK_DONE_CONFIRM_WARNING", scope)}
                />
            )}
            cancelButton={{
                title: getTranslation("BULK_MARK_DONE_CONFIRM_CANCEL", scope),
                onClick: onCancel,
                disabled: isLoading,
            }}
            okButton={{
                title: getTranslation("BULK_MARK_DONE_CONFIRM", scope, [count]),
                onClick: onConfirm,
                disabled: selectionCount <= 0 || isLoading,
                hasLoader: true,
                isLoading,
                variant: BUTTON_VARIANTS.Primary,
            }}
        />
    );
});

export default RmaListBulkMarkDoneConfirmModal;
